import styled from 'styled-components';
import {
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledBar = styled.div`
    border: 1px solid ${token('colors.yellow300')};
    width: 100%;
    max-width: 142px;
    margin: ${spaceMixin('md')} auto ${spaceMixin('lg')} auto;
`;

export const StyledIconContainer = styled.div`
    width: 32px;
    height: 32px;
`;

export const StyledInfoContainer = styled.div`
    margin: auto;
    max-width: 460px;
`;
